import { t } from '../../lang';
import Icon, { Icons } from '../Icon/Icon';
import './EmptyCurrency.scss';

const EmptyCurrency = () => {
	return (
		<div className='empty-currency'>
			<Icon type={Icons.EMPTY_CURRENCY_ICON} width={240} height={124} />
			<div className='empty-currency__title'>{t('No assets yet')}</div>
			<div className='empty-currency__subtitle'>{t("They'll appear here soon")}</div>
		</div>
	);
};

export default EmptyCurrency;
